import { PrimaryButton, ErrorPage } from '@luminalearning/components';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import useScreenSize from 'src/hooks/useScreenSize';

const Four04 = () => {
    const intl = useIntl();
    const [width] = useScreenSize();
    const navigate = useNavigate();

    return (
        <div className='static overflow-hidden w-full h-full'>
            <ErrorPage
                error={{
                    title: intl.formatMessage({
                        id: 'LP_PAGE_404',
                        defaultMessage: 'Error 404',
                    }),
                    description: intl.formatMessage({
                        id: 'LP_PAGE_404_DESC',
                        defaultMessage:
                            "Sorry, the page you're looking for cannot be found",
                    }),
                }}
                buttons={
                    <PrimaryButton
                        onClick={() => navigate('')}
                        text={intl.formatMessage({
                            id: 'LP_BACKTO_DASHBOARD',
                            defaultMessage: 'Back to Practitioner Dashboard',
                        })}
                    />
                }
                size={width < 1020 ? 'Small' : 'Normal'}
                className="pb-4"
            />
        </div>
    );
};

export default Four04;
